var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZipLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.725 1.275H1.275V10.8375H15.725V1.275ZM0 0V12.1125H17V0H0Z",
    fill: "url(#paint0_linear_721_19541)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.47985C4.25 4.00082 4.63832 3.6125 5.11735 3.6125H11.8827C12.3617 3.6125 12.75 4.00082 12.75 4.47985C12.75 4.95887 12.3617 5.34719 11.8827 5.34719H5.11735C4.63832 5.34719 4.25 4.95887 4.25 4.47985Z",
    fill: "url(#paint1_linear_721_19541)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7375 7.75625C5.7375 8.16701 5.40451 8.5 4.99375 8.5C4.58299 8.5 4.25 8.16701 4.25 7.75625C4.25 7.34549 4.58299 7.0125 4.99375 7.0125C5.40451 7.0125 5.7375 7.34549 5.7375 7.75625Z",
    fill: "url(#paint2_linear_721_19541)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 7.75625C8.075 8.16701 7.74201 8.5 7.33125 8.5C6.92049 8.5 6.5875 8.16701 6.5875 7.75625C6.5875 7.34549 6.92049 7.0125 7.33125 7.0125C7.74201 7.0125 8.075 7.34549 8.075 7.75625Z",
    fill: "url(#paint3_linear_721_19541)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4125 7.75625C10.4125 8.16701 10.0795 8.5 9.66875 8.5C9.25799 8.5 8.925 8.16701 8.925 7.75625C8.925 7.34549 9.25799 7.0125 9.66875 7.0125C10.0795 7.0125 10.4125 7.34549 10.4125 7.75625Z",
    fill: "url(#paint4_linear_721_19541)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.75625C12.75 8.16701 12.417 8.5 12.0063 8.5C11.5955 8.5 11.2625 8.16701 11.2625 7.75625C11.2625 7.34549 11.5955 7.0125 12.0063 7.0125C12.417 7.0125 12.75 7.34549 12.75 7.75625Z",
    fill: "url(#paint5_linear_721_19541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_19541",
    x1: 16.1053,
    y1: 12.1125,
    x2: 0.160291,
    y2: 1.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_19541",
    x1: 16.1053,
    y1: 12.1125,
    x2: 0.160291,
    y2: 1.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_721_19541",
    x1: 16.1053,
    y1: 12.1125,
    x2: 0.160291,
    y2: 1.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_721_19541",
    x1: 16.1053,
    y1: 12.1125,
    x2: 0.160291,
    y2: 1.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_721_19541",
    x1: 16.1053,
    y1: 12.1125,
    x2: 0.160291,
    y2: 1.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_721_19541",
    x1: 16.1053,
    y1: 12.1125,
    x2: 0.160291,
    y2: 1.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipLogo);
export default __webpack_public_path__ + "static/media/zipLogo.03ff09d5a621d90468f8a3ff5faf844b.svg";
export { ForwardRef as ReactComponent };